<template>
  <div class="employeeSchedule">
    <template v-for="(schedule, name, idx) in scheduleEmployeesList">
      <div :key="name" class="table" v-if="onVisibleTab(idx + 1)">
        <div class="employeeSchedule_title">Week: {{ idx + 1 }}</div>
        <div class="table_head">
          <div class="table_head-th">№</div>
          <div
            class="table_head-th"
            :class="{ disabled: item.disabled, 'active': currentDate === name }"
            :key="name"
            v-for="(item, name, idx) in schedule"
          >
            <span>{{ dayOfWeek[idx] }}</span>
            <span>{{ name }}</span>
          </div>
        </div>
        <div class="table_body" :key="i" v-for="i in 3">
          <div class="table_body-td">{{ i }}</div>
          <div
            class="table_body-td"
            :class="{ disabled: body.disabled }"
            :key="value + idx"
            v-for="(body, value, idx) in schedule"
          >
            <ul>
	            <li
			            v-for="{ name, id, user_id } in body.schedules[i].employees"
			            :key="id"
			            :class="{ active: isEmployeeActive(user_id) }"
			            :style="getEmployeeStyle(user_id)"
	            >
		            {{ name }}
	            </li>
            </ul>
            <button @click="onHandlerPopup({ day: value, schedule: i })" class="table_body-td--btn">
              <svg-sprite width="16" height="16" icon-id="edit"></svg-sprite>
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "EmployeeSchedule",
	props: {
		scheduleEmployeesList: Object,
		week: Array,
		employeeId: Number,
		employeeList: {
			type: Array,
			default: () => [],
		},
		currentDate: String
	},
	data: () => ({
		dayOfWeek: [
			"Sunday",
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday",
		],
	}),
	computed: {
		/**
		 * Возвращает список ID выбранных сотрудников.
		 *
		 * @returns {Set<number>} Набор идентификаторов сотрудников.
		 */
		employeeIds() {
			const employees = Array.isArray(this.employeeList)
				? this.employeeList
				: [];

			return new Set(
				employees
					.map(employee => Number(employee.id))
					.filter(id => Number.isFinite(id))
			);
		},
	},
	methods: {
		...mapActions([ "getScheduleEmployee" ]),

		/**
		 * Проверяет, выбран ли сотрудник.
		 *
		 * @param {number|string} userId ID сотрудника.
		 * @returns {boolean} Выбран ли сотрудник.
		 */
		isEmployeeActive(userId) {
			const normalizedUserId = Number(userId);

			return normalizedUserId === Number(this.employeeId)
					|| this.employeeIds.has(normalizedUserId);
		},

		/**
		 * Создаёт стабильное числовое значение из ID сотрудника.
		 *
		 * @param {number|string} userId ID сотрудника.
		 * @returns {number} Числовой хеш.
		 */
		getEmployeeHash(userId) {
			const value = String(userId);

			return value.split("").reduce((hash, char) => {
				return ((hash * 31) + char.charCodeAt(0)) % 1000000;
			}, 7);
		},

		/**
		 * Генерирует приглушённый цвет сотрудника.
		 *
		 * @param {number|string} userId ID сотрудника.
		 * @returns {Object} Стили сотрудника.
		 */
		getEmployeeColor(userId) {
			const hash = this.getEmployeeHash(userId);

			const hue = Math.round((hash * 137.508) % 360);
			const saturation = 42 + (hash % 12);
			const lightness = 38 + (Math.floor(hash / 10) % 10);

			return {
				backgroundColor: `hsl(${ hue }, ${ saturation }%, ${ lightness }%)`,
				borderColor: `hsl(${ hue }, ${ saturation }%, ${ lightness + 8 }%)`,
				color: "#ffffff",
			};
		},

		/**
		 * Возвращает стиль только для выбранного сотрудника.
		 *
		 * @param {number|string} userId ID сотрудника.
		 * @returns {Object} Стили сотрудника.
		 */
		getEmployeeStyle(userId) {
			if (!this.isEmployeeActive(userId)) {
				return {};
			}

			return this.getEmployeeColor(userId);
		},

		/**
		 * Проверяет видимость недели.
		 *
		 * @param {number} index Номер недели.
		 * @returns {boolean} Видима ли неделя.
		 */
		onVisibleTab(index) {
			const weeks = Array.isArray(this.week) ? this.week : [];

			return weeks.some(item => item.value === index);
		},

		/**
		 * Открывает окно редактирования расписания.
		 *
		 * @param {Object} value Данные выбранного расписания.
		 * @returns {void}
		 */
		onHandlerPopup(value) {
			this.$emit("onHandlerPopup", value);
		},
	},
};
</script>

<style scoped lang="scss">
@import "employeeSchedule";
</style>
